import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import { CommissionService } from "@foundation/_routes/commissions/commission.service";
import { DeviceInstallEditor } from "@foundation/_routes/commissions/commissionEditor/components/deviceInstallEditor/device-install-editor.component";
import * as angular from "angular";
import { CommissionDetailComponent } from "./commission-detail/commission-detail.component";
import { CommissionListComponent } from "./commission-list.component";
import { VCommissionEditorComponent } from "./commissionEditor/commission-editor.component";

angular
    .module("app.foundation.commission", ["app.directives","app.foundation.components"])
    //.config(Config)

    .directive("foundationDeviceInstallEditor", downgradeComponent({ component: DeviceInstallEditor }))
    .directive("commissionList", downgradeComponent({ component: CommissionListComponent }))
    .directive("commissionDetail", downgradeComponent({ component: CommissionDetailComponent }))
    .directive("commissionEditor", downgradeComponent({ component: VCommissionEditorComponent }))

    .service("commissionService", downgradeInjectable(CommissionService));
